let _this;
import { NodeHandleType } from "../../incidentManagement/components/esop/utils/enum";
import playVideo from '../../commonComponents/utmPlayVideo.vue'
import utmFilesPanel from '../../commonComponents/utm-files-panel/utm-files-panel.vue'
export default {
  name: "task-detail",
  components: {
    playVideo,
    utmFilesPanel
  },
  data() {
    return {
        showOpenDetails:false,
        historyList:[],
        node:null,
        incidentId:'',
        level:{},
        NodeHandleType,
        videoModal:false,
        audioWrapper: null,
        audioSchedule:0,
        audioFlag:false,
        videoSrc:'',
        linkAges:[]
    };
  },
  methods:{
        returnHasData(){
           let status = true
           if((this.linkAges.length == 0 && this.remarksList.length == 0 && this.historyList.length == 1) ||(this.linkAges.length == 1 && this.remarksList.length == 0 && this.historyList.length == 1 && this.historyList[0].taskId == this.linkAges[0].taskId)){
            let item = this.historyList[0]
              if(item.esopTaskOperatorType == 0){
                status = (item.extension.label && item.extension.value) || item.remark || item.attachments.length > 0 || item.receivers.length > 0
              }
           }
           return this.linkAges.length + this.historyList.length + this.remarksList.length > 0 && status
        },
        // 预览附件
        viewAttachment (item) {
          let url = null;
          let _this = this
          if (item.fileId) {
            url = _this.$root.fileBaseUrl + 'Files/Get/' + item.fileId + '?access_token=' + _this.ApiService.accessToken.substr(7);
          } else if (item.fileData) {
            url = item.imgBase64Type + item.fileData;
          }
          if (item.type === 1) {
            _this.videoModal = true;
            _this.$nextTick(() => {
              _this.$refs.messageVideo.palyVideoUrl(url);
            })
          } else if (item.type === 2) {
            if (_this.audioWrapper) {
              _this.audioWrapper.pause();
              _this.audioWrapper.load();
              _this.audioWrapper.src = url;
              _this.audioSchedule = 0;
              _this.audioWrapper.play();
              _this.audioFlag = true;
              _this.audioWrapper.addEventListener('ended', function () {
                _this.audioFlag = false;
              }, false);
              _this.audioWrapper.addEventListener("timeupdate", function () {//监听音频播放的实时时间事件
                //用秒数来显示当前播放进度
                _this.audioSchedule = (_this.audioWrapper.currentTime / _this.audioWrapper.duration).toFixed(2);
              }, false);
            } else {
              _this.audioWrapper = new Audio(url);
              _this.audioSchedule = 0;
              _this.audioWrapper.play();
              _this.audioFlag = true;
              _this.audioWrapper.addEventListener('ended', function () {
                _this.audioFlag = false;
              }, false);
              _this.audioWrapper.addEventListener("timeupdate", function () {//监听音频播放的实时时间事件
                //用秒数来显示当前播放进度
                _this.audioSchedule = (_this.audioWrapper.currentTime / _this.audioWrapper.duration).toFixed(2);
              }, false);
            }
          } else if (item.type === 0) {
            _this.$root.viewBigImg(url);
          }
        },
        downloadFile(url) {
          // 创建一个隐藏的<a>元素
          let link = document.createElement('a');
          link.href = url;
          link.download = url.split('/').pop(); // 设置下载文件的名称为URL的最后部分
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
      },
    open(id,node){
        this.node = node;
        this.incidentId = id
        this.getTaskHistory()
        this.$ajax.get('incidentPriority/GetAll').then((res)=>{
                   if(res.data.success){
                    res.data.data.forEach((item)=>{
                      this.level[item.level]=item.color;
                    })
                   }
        })
    },
    getTaskHistory(){
      this.$ajax.get('IncidentRecord/GetIncidentRecordEsopTaskHistory?IncidentRecordId='+this.incidentId + '&taskId='+this.node.id).then((res)=>{
        if(res.data.success){
          res.data.data.items.forEach(element => {
            if(element.extension){
              element.extension = JSON.parse(element.extension )
            }
          });
            this.historyList = res.data.data.items
            this.remarksList = res.data.data.items.filter((item)=>{
              return item.esopTaskOperatorType === 3
            })
    
            this.linkAges = res.data.data.items.filter((item)=>{
              return item.extension.linkAges
            })
            this.linkAges.forEach((link)=>{
                link.extension.linkAges = JSON.parse(link.extension.linkAges)
            })
            this.historyList = res.data.data.items.filter((item)=>{
              return item.esopTaskOperatorType !== 3
            })
            this.showOpenDetails = true;
        }
      })
  },
  }

};



// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/esop-incident-task-details/index.js